import { datadogRum } from '@datadog/browser-rum';
import { v4 as uuid } from 'uuid';
import { Analytics } from '@services/analytics-service';
import { setSarSessionId, setConcernLocationDraftPromise } from '@store/sar-store';

export const treatAsUTC = (date: number | string) => {
  const result = new Date(date);
  result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
  return result;
};

export const daysSince = (initialDate: number | string) => {
  const millisecondsPerDay = 24 * 60 * 60 * 1000;
  const currentDate: any = treatAsUTC(Date.now());
  const startDate: any = treatAsUTC(initialDate);
  return (currentDate - startDate) / millisecondsPerDay;
};

export const aOrAn = (noun = '') => ('aeiou'.split('').includes(noun?.[0]?.toLowerCase()) ? 'an' : 'a');

export const setSessionId = () => {
  const sessionId = uuid();
  setConcernLocationDraftPromise(null); // new session = no pending concern selection yet
  datadogRum.setGlobalContext({
    sarSessionId: sessionId,
  });
  Analytics.setGlobalCustomAttributes({ sarSessionId: sessionId });
  setSarSessionId(sessionId);
};

export const clearSessionId = () => {
  datadogRum.removeGlobalContextProperty('sarSessionId');
  Analytics.setGlobalCustomAttributes({ sarSessionId: undefined });
  setSarSessionId(undefined);
  setConcernLocationDraftPromise(null);
};
